export const isAuthenticated = (state) => !!state.token